import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
  Alert,
  Stack,
} from "@mui/material";
import { useState } from "react";
import { useGetAdminsQuery } from "../../app/services/authApi";

function AttachAdminModal({ open, onClose, onAttach }) {
  const [search, setSearch] = useState("");
  const { data, isLoading, isError, error } = useGetAdminsQuery("admin");

const filteredUsers = (data || []).filter(
  (u) =>
    u.id.toString().includes(search) || // recherche par ID
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase())
);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          // width: 800,
          maxHeight: "80vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Rechercher un administrateur
        </Typography>

        <TextField
          fullWidth
          placeholder="Id ou nom ou email"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
        />

        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : isError ? (
          <Alert severity="error">Erreur : {error.message}</Alert>
        ) : filteredUsers.length === 0 ? (
          <Typography>Aucun administrateur trouvé.</Typography>
        ) : (
          <Table size="small">
            <TableBody>
              {filteredUsers.map((user) => (
                <TableRow key={user.id}>
                    <TableCell>{user.id}</TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell align="right">
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => {
                        onAttach(user.id);
                        onClose();
                      }}
                    >
                      Attacher
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 3 }}>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Annuler
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default AttachAdminModal;
